import { useState } from 'react';
import { Link } from 'react-router-dom';
import { COMPANY_INFO } from '../data/staticData';
import { submitWebform } from '../lib/cmsClient';
import FileUploadField from '../components/FileUploadField';

export default function ContactPage() {
  const [formState, setFormState] = useState({
    Navn: '',
    Mail: '',
    Mobil: '',
    Adresse: '',
    Postnummer: '',
    Besked: '',
    Finansiering: false,
    AccepterBetingelser: false,
    website_url: '' // Mandatory honeypot
  });
  const [files, setFiles] = useState([]);

  const [submitting, setSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formState.AccepterBetingelser) {
      alert('Du skal acceptere vilkårene for privatlivspolitik for at sende formularen.');
      return;
    }

    setSubmitting(true);
    setSubmitStatus(null);

    let res;
    if (files.length > 0) {
      const formData = new FormData();
      formData.append('Navn', formState.Navn);
      formData.append('Mail', formState.Mail);
      formData.append('email', formState.Mail);
      formData.append('Mobil', formState.Mobil);
      formData.append('Adresse', formState.Adresse);
      formData.append('Postnummer', formState.Postnummer);
      formData.append('Besked', formState.Besked);
      formData.append('Finansiering', formState.Finansiering ? 'Ja' : 'Nej');
      formData.append('website_url', formState.website_url); // Honeypot
      files.forEach((file) => {
        formData.append('billeder', file);
      });
      res = await submitWebform(formData);
    } else {
      const payload = {
        Navn: formState.Navn,
        Mail: formState.Mail,
        email: formState.Mail,
        Mobil: formState.Mobil,
        Adresse: formState.Adresse,
        Postnummer: formState.Postnummer,
        Besked: formState.Besked,
        Finansiering: formState.Finansiering,
        website_url: formState.website_url // Honeypot
      };
      res = await submitWebform(payload);
    }

    setSubmitting(false);

    if (res.ok) {
      setSubmitStatus('success');
      setFiles([]);
      setFormState({
        Navn: '',
        Mail: '',
        Mobil: '',
        Adresse: '',
        Postnummer: '',
        Besked: '',
        Finansiering: false,
        AccepterBetingelser: false,
        website_url: ''
      });
    } else {
      setSubmitStatus('error');
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-20 lg:pt-24 pb-20 sm:pb-28 lg:pb-36 space-y-16">
      
      {/* Header */}
      <div className="text-left max-w-4xl space-y-6">
        <h1 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold text-stone-900 tracking-tight uppercase">
          Kontakt teamet fra Dansk Tagbyg
        </h1>
        <p className="text-stone-700 text-lg sm:text-xl leading-relaxed">
          Har du nogen spørgsmål? Så er du altid meget velkommen til at kontakte os. Det er ganske uforpligtende, og vi vil rigtig gerne rådgive dig om{' '}
          <Link to="/nyt-tag" className="text-[#BE0F12] font-semibold underline hover:text-black">
            nyt tag
          </Link>{' '}
          samt hvilke muligheder vi tilbyder, hvordan vi vil gribe projektet an og meget mere.
        </p>
        <p className="text-stone-700 text-base leading-relaxed">
          Du kan også udfylde vores kontaktformular her på siden, så vender vi hurtigst muligt tilbage. Tilføj gerne billeder eller beskrivelse af dit tag, så kan vi give et uforpligtende prisestimat på projektet.
        </p>
        <p className="text-stone-700 text-base leading-relaxed">
          Besøg også gerne vores{' '}
          <Link to="/projekter" className="text-[#BE0F12] font-semibold underline hover:text-black">
            tidligere projekter
          </Link>{' '}
          for at få inspiration til dit næste projekt.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 sm:gap-16 items-start">
        
        {/* Left Column: Direct Contact Info */}
        <div className="lg:col-span-5 space-y-8">
          <div className="bg-stone-50 border border-stone-200 p-8 space-y-6">
            <h2 className="text-2xl font-extrabold text-stone-900 uppercase">
              Direkte kontakt
            </h2>
            
            <div className="space-y-4 text-sm sm:text-base">
              <div>
                <span className="text-xs uppercase font-bold text-stone-500 block">Ring til os:</span>
                <a
                  href={COMPANY_INFO.phoneTel}
                  className="nowrap-contact text-xl font-bold text-stone-900 hover:text-[#BE0F12] transition-colors"
                >
                  {COMPANY_INFO.phoneFormatted}
                </a>
              </div>

              <div>
                <span className="text-xs uppercase font-bold text-stone-500 block">Skriv til os:</span>
                <a
                  href={COMPANY_INFO.emailMailto}
                  className="nowrap-contact text-base font-bold text-stone-900 hover:text-[#BE0F12] transition-colors"
                >
                  {COMPANY_INFO.email}
                </a>
              </div>

              <div className="pt-2 border-t border-stone-200">
                <span className="text-xs uppercase font-bold text-stone-500 block">Adresse:</span>
                <p className="text-stone-800 font-medium">{COMPANY_INFO.address}</p>
              </div>

              <div>
                <span className="text-xs uppercase font-bold text-stone-500 block">CVR:</span>
                <p className="text-stone-800 font-medium">{COMPANY_INFO.cvr}</p>
              </div>
            </div>
          </div>

          {/* Anmeld Håndværker */}
          <div className="p-6 bg-white border border-stone-200 text-center space-y-3 shadow-sm">
            <div className="flex justify-center gap-1 text-amber-500 text-lg">
              <i className="fa-solid fa-star"></i>
              <i className="fa-solid fa-star"></i>
              <i className="fa-solid fa-star"></i>
              <i className="fa-solid fa-star"></i>
              <i className="fa-solid fa-star"></i>
            </div>
            <a
              href="https://www.anmeld-haandvaerker.dk/tagdaekker/dansk-tagbyg-aps"
              target="_blank"
              rel="noreferrer"
              className="block font-black text-xl text-stone-900 hover:text-[#BE0F12] transition-colors"
            >
              4,8 ud af 155 anmeldelser
            </a>
            <p className="text-xs text-stone-500">
              Finalist til Årets Håndværker 5 år i træk
            </p>
          </div>

          {/* Lasse foto med "Har du spørgsmål..." */}
          <div className="flex flex-row items-end justify-center gap-2 sm:gap-3 pt-2">
            <img
              src="https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/har-du-sporgsmaal.png"
              alt="Har du spørgsmål, så tag fat i mig!"
              className="w-[42%] max-w-[145px] h-auto object-contain self-center"
            />
            <img
              src="https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/lasse-sidebar.png"
              alt="Lasse Vesterhouen - Dansk Tagbyg"
              className="w-[58%] max-w-[200px] h-auto object-contain"
            />
          </div>
        </div>

        {/* Right Column: Contact Form */}
        <div id="kontakt" className="lg:col-span-7 bg-white border border-stone-200 p-8 sm:p-10 shadow-sm scroll-mt-32">
          <h2 className="text-2xl font-bold text-stone-900 uppercase mb-6">
            Send os en besked
          </h2>

          {submitStatus === 'success' && (
            <div className="mb-6 p-4 bg-emerald-50 border border-emerald-300 text-emerald-900 text-sm">
              <p className="font-bold">Mange tak for din henvendelse!</p>
              <p>Vi har modtaget din besked og vender tilbage hurtigst muligt.</p>
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="mb-6 p-4 bg-red-50 border border-red-300 text-red-900 text-sm">
              <p className="font-bold">Der opstod en fejl ved afsendelse.</p>
              <p>Prøv venligst igen eller ring direkte til os på {COMPANY_INFO.phoneFormatted}.</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Honeypot field (hidden from humans per Rule 12) */}
            <div className="sr-only absolute left-[-9999px]" aria-hidden="true">
              <label htmlFor="website_url">Hjemmeside url (lad stå tom)</label>
              <input
                type="text"
                id="website_url"
                name="website_url"
                value={formState.website_url}
                onChange={handleInputChange}
                tabIndex={-1}
                autoComplete="off"
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-bold uppercase tracking-wider text-stone-700 mb-1">
                  Navn *
                </label>
                <input
                  type="text"
                  name="Navn"
                  required
                  value={formState.Navn}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2.5 border border-stone-300 bg-white text-stone-900 text-sm focus:border-black focus:outline-none"
                  placeholder="Dit fulde navn"
                />
              </div>

              <div>
                <label className="block text-xs font-bold uppercase tracking-wider text-stone-700 mb-1">
                  Mail *
                </label>
                <input
                  type="email"
                  name="Mail"
                  required
                  value={formState.Mail}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2.5 border border-stone-300 bg-white text-stone-900 text-sm focus:border-black focus:outline-none"
                  placeholder="din@mail.dk"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="sm:col-span-1">
                <label className="block text-xs font-bold uppercase tracking-wider text-stone-700 mb-1">
                  Mobil *
                </label>
                <input
                  type="tel"
                  name="Mobil"
                  required
                  value={formState.Mobil}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2.5 border border-stone-300 bg-white text-stone-900 text-sm focus:border-black focus:outline-none"
                  placeholder="Mobilnummer"
                />
              </div>

              <div className="sm:col-span-2">
                <label className="block text-xs font-bold uppercase tracking-wider text-stone-700 mb-1">
                  Adresse *
                </label>
                <input
                  type="text"
                  name="Adresse"
                  required
                  value={formState.Adresse}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2.5 border border-stone-300 bg-white text-stone-900 text-sm focus:border-black focus:outline-none"
                  placeholder="Vejnavn og nummer"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-stone-700 mb-1">
                Postnummer *
              </label>
              <input
                type="text"
                name="Postnummer"
                required
                value={formState.Postnummer}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-stone-300 bg-white text-stone-900 text-sm focus:border-black focus:outline-none"
                placeholder="F.eks. 8000"
              />
            </div>

            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-stone-700 mb-1">
                Besked *
              </label>
              <textarea
                name="Besked"
                required
                rows={5}
                value={formState.Besked}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-stone-300 bg-white text-stone-900 text-sm focus:border-black focus:outline-none resize-y"
                placeholder="Beskriv dit projekt eller stil dine spørgsmål her..."
              ></textarea>
            </div>

            {/* Vedhæft filer */}
            <FileUploadField
              files={files}
              onFilesChange={setFiles}
              idPrefix="contact-page"
              label="Vedhæft evt. 1-5 billeder af dit hus på afstand, hvor man kan se taget"
            />

            {/* Finansiering checkbox */}
            <div className="flex items-start gap-3">
              <input
                type="checkbox"
                id="Finansiering"
                name="Finansiering"
                checked={formState.Finansiering}
                onChange={handleInputChange}
                className="mt-1 h-4 w-4 rounded-none border-stone-300 text-black focus:ring-black"
              />
              <label htmlFor="Finansiering" className="text-xs text-stone-700 leading-normal cursor-pointer">
                Har du finansieringen på plads og ønsker et tilbud?
              </label>
            </div>

            {/* Accepter betingelser checkbox */}
            <div className="flex items-start gap-3">
              <input
                type="checkbox"
                id="AccepterBetingelser"
                name="AccepterBetingelser"
                required
                checked={formState.AccepterBetingelser}
                onChange={handleInputChange}
                className="mt-1 h-4 w-4 rounded-none border-stone-300 text-black focus:ring-black"
              />
              <label htmlFor="AccepterBetingelser" className="text-xs text-stone-700 leading-normal cursor-pointer">
                Jeg har læst og accepteret vilkårene for brug af oplysninger og privatlivspolitik. *
              </label>
            </div>

            <div className="pt-2">
              <button
                type="submit"
                disabled={submitting}
                className="w-full py-3.5 px-6 bg-stone-900 hover:bg-black disabled:bg-stone-400 text-white font-bold text-sm uppercase tracking-wider transition-colors shadow-md cursor-pointer"
              >
                {submitting ? 'Sender...' : 'Send besked'}
              </button>
            </div>
          </form>
        </div>

      </div>

    </div>
  );
}
